<template>
  <div class="c-star">
    <img v-for="(star, index) in stars" :key="index" :src="star" class="c-star-item" />
    <span class="c-star-value">{{ (value * 1.0).toFixed(1) }}</span>
  </div>
</template>

<script>
import starEmpty from '@/assets/images/star/star0@2x.png';
import starQuarter from '@/assets/images/star/star1@2x.png'; // 四分之一
import starHalf from '@/assets/images/star/star2@2x.png'; // 半颗
import starThreeQuarters from '@/assets/images/star/star3@2x.png'; // 四分之三
import starFull from '@/assets/images/star/star4@2x.png'; // 满星

export default {
  props: {
    value: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0 && val <= 10,
    },
  },
  data() {
    return {
      starEmpty,
      starQuarter,
      starHalf,
      starThreeQuarters,
      starFull,
    };
  },
  computed: {
    stars() {
      const totalStars = 10;
      const images = [];
      // console.log('========== stars =======');
      for (let i = 0; i < totalStars; i = i + 2) {
        const diff = this.value - i;
        // console.log('diff', diff);
        if (diff >= 2) {
          images.push(this.starFull);
        } else if (diff > 1) {
          images.push(this.starThreeQuarters);
        } else if (diff > 0.5) {
          images.push(this.starHalf);
        } else if (diff > 0) {
          images.push(this.starQuarter);
        } else {
          images.push(this.starEmpty);
        }
      }

      return images;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-star {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 14px;
  gap: 3px;
  &-item {
    width: 14px;
    height: 14px;
  }
  &-value {
    margin-top: 2px;
    margin-left: 5px;
    font-weight: 500;
    line-height: 1.5;
    font-size: 12px;
    color: #3e24d3;
  }
}
</style>
